import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
export default class NotificationFarmModel extends BaseModel {

    constructor() {
        super({
                name: "notification_farm",
                tableName: 'notification_farm',
                label: "Thông Báo Trang trại",
                display_key: 'name',
                default_order: { key: 'updated_at', direction: 'asc' }
            },
            {
                id: {
                    name: "id",
                    display: false
                },
                farm_id: {
                    name: 'uid',
                    display: false
                },
                notification_id: {
                    name: 'notification_id',
                    display: false
                },
            },
            )
    }

}